// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {fuelSelector, getFuel, insertFuel, updateFuel,} from "./fuelSlice";

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const FuelPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const fuel = useSelector(fuelSelector);

    useEffect(() => {
        dispatch(
            getFuel({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && fuel.isGetSuccess && !fuel.isGetFetching) {
            let calc = fuel?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = fuel.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && fuel.isGetSuccess && !fuel.isGetFetching) {
            let calc = fuel?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = fuel.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !fuel?.isGetFetching &&
            fuel.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = fuel?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = fuel.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getFuel({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (fuel.isGetSuccess) {
                alertService.success(fuel.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getFuel({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (fuel.isUpdateSuccess) {
                alertService.success(fuel.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateFuel({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetFuel(params) {
    //   return dispatch(getFuel(params));
    // }

    function handleInsertFuel(param) {
        setInsertFetch(true);
        const params = {
            FuelName: param.inputOneValue,
        };

        dispatch(insertFuel(params));
    }

    function handleUpdateFuel(param) {
        setUpdateFetch(true);

        const params = {
            FuelName: param.inputOneValue,
            FuelID: currentData.FuelID,
            status: param.status,
        };
        dispatch(updateFuel(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getFuel(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getFuel(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = fuel.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? fuel.count : newCount,
            search: search,
        };
        dispatch(getFuel(params));

        setPage(1);
        setCount(newCount === "-1" ? fuel.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Fuel"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Fuel"
                                tableData={fuel.data}
                                colOneTitle="ID"
                                colOneData="FuelID"
                                colTwoTitle="Nama Fuel"
                                colTwoData="FuelName"
                                status="Status"
                                fetching={fuel.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Fuel"
                        inputOneTitle="Nama Fuel"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertFuel}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.FuelID}
                        modal={handleModal}
                        modalTitle="Ubah Fuel"
                        inputOneTitle="Nama Fuel"
                        inputOneValue={currentData.FuelName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateFuel}
                    />
                )}
            </div>
        );
    }
};

export default FuelPage;
